<template>
    <div>
        <div class="seachBox flex">
            <div class="seachList"><span class="name">关键字：</span>
                <a-input placeholder="" class="seachs" v-model="seach.keyword"/>
            </div>
            <div class="seachList  ">
                <a-button type="primary" size="default" class="seachBtn" @click="getList(1)" style="margin-right: 15px">
                    查询
                </a-button>
                <a-button size="default" class="seachBtn" @click="resetSeach()">重置</a-button>
            </div>
            <div class="seachList no"></div>
            <div class="seachList no"></div>
            <div class="seachList no"></div>
        </div>

        <div style="margin-bottom: 10px"  >

            <a-popconfirm
                    title="此操作将永久删除, 是否继续?"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="editLanguage('','5')"
                    @cancel="()=>{}"
                    :disabled="!hasSelected"
            >
                <a-button  type="primary" :disabled="!hasSelected"  >
                    删除
                </a-button>
            </a-popconfirm>

            <span style="margin-left: 8px">
                <template v-if="hasSelected">
                  {{ `选中 ${selectedRowKeys.length} 项` }}
                </template>
            </span>
        </div>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id"
                 :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }">

            <span slot="action" slot-scope="text, record"> <a @click="details(text.id )">查看详情</a></span>
        </a-table>

    </div>
</template>

<script>
    import API from "./api";
    import moment from 'moment';
    import {changStatus, removeById,orderList} from "../../utils/utils"
    const columns = [
        {
            title: "收件人",
            dataIndex: "customer_name_format",
            ellipsis: true,
            key: "customer_name_format",
        },
        {
            title: "主题",
            dataIndex: "theme",
            ellipsis: true,
            key: "theme"
        },
        {
            title: "时间",
            dataIndex: "create_time_format",
            ellipsis: true,
            key: "create_time",
        },
        {
            title: "操作",
            key: "action",
            width: "150px",
            fixed: 'right',
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: "Letter",
        data() {
            return {
                resetSeachdata:true,
                seachList:[],
                visibleImg: false,
                tableImg: "",
                seach: {
                    keyword:"",
                },
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
                data: [],
                columns,
                selectedRowKeys:[], // Check here to configure the default column
                loading: true,
                visible: false,
                title: "",
                editId: null
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/CustomerManagement/Letter"; //设置左侧导航2-2 active
        },
        mounted() {
            this.getList()
        },
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        methods: {
            details(id){
                this.$router.push({path: '/CustomerManagement/WriteDetails', query: {id:id}})
            },
            confirm(id) {
                removeById(API.writeLetters.DELE,id).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },
            resetSeach() {
                this.loading = true
                this.seach = {
                    keyword:""
                }
                this.resetSeachdata=false
                this.getList(1)
            },
            getList(page) {
                API.writeLetters.LETTER_LIST({page: page || 1, ...this.seach}).then(res => {
                    this.data = res.data.data.info.data
                    this.pagination.total = res.data.data.info.total
                    this.pagination.pageSize = res.data.data.info.per_page
                    this.pagination.current = res.data.data.info.current_page
                    this.resetSeachdata=true
                    this.loading = false
                })
                this.selectedRowKeys=[]
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            editLanguage(name, type) {
                if (type == '5') {
                    this.confirm(this.selectedRowKeys)
                }
                let url
                let dataArr = []
                let dataJson = {}
                this.selectedRowKeys.map((item, index) => {
                    dataJson = {}
                    dataJson.id = item;
                    dataJson[name] = type;
                    dataArr.push(dataJson)
                })
            },
        }
    }
</script>

<style scoped>
    .seachBox .seachList .name { width: 70px !important;}
    .seachBox .seachList .seachs { width: calc(100% - 80px);}
</style>
